import React from 'react';

import classNames from 'classnames';

import currencyIcon from './assets/pound.svg';

import './styles.css';

interface MoneyInputProps {
  value?: string;
  defaultValue?: string;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  disabled?: boolean;
  min?: string;
  step?: any;
  placeholder?: string;
}

const MoneyInput = ({
  value,
  defaultValue,
  onChange,
  onBlur,
  placeholder,
  min = '0',
  step = 'any',
  disabled
}: MoneyInputProps) => {
  return (
    <div className={classNames('MoneyInput', {disabled})}>
      <div className="inputWrapper">
        <div className="icon colab-centered">
          <img src={currencyIcon} alt="Pound icon" />
        </div>
        <input
          onBlur={onBlur}
          onChange={onChange}
          placeholder={placeholder}
          type="number"
          min={min}
          step={step}
          value={value}
          disabled={disabled}
          defaultValue={defaultValue}
        />
      </div>
    </div>
  );
};

export default MoneyInput;
